import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { NzFlexModule } from 'ng-zorro-antd/flex';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'app-notFound-page',
  imports: [NzIconModule, NzFlexModule, TranslatePipe, RouterLink],
  templateUrl: './not-found.page.html'
})
export class NotFoundPage {}
